import { NativeSelect, withStyles } from '@material-ui/core';

export const BasicSelect = withStyles(() => ({
  root: {
    backgroundColor: '#fff',
    '&:focus': {
      backgroundColor: '#fff'
    }
  }
}))(NativeSelect);
